import AbstractModule from "../abstract_module";
import IHUDModule from "./scene_hud_interface";
import RenderDocument from "js_renderer";
import {CompassTypeEnum} from "./scene_hud_enums";
import Settings from "../settings";
import {vec2} from "gl-matrix";
import Scene from "../../scene";
import IBackgroundModule from "../background/scene_background_interface";

interface IAxesCross {
    enabled?: boolean;
}

interface ICompassSettings {
    enabled?: boolean;
    type?: CompassTypeEnum;
    tilt?: boolean;
}

interface ISightPointSettings {
    enabled?: boolean;
    width?: number;
    height?: number;
    textureUrl?: string;
}

interface IHUDSettings {
    axesCross?: IAxesCross;
    compass?: ICompassSettings;
    sightPoint?: ISightPointSettings;
}

export default
class HUDModule extends AbstractModule implements IHUDModule {

    protected static _typeName: string = "hud";

    protected _defaultSettings: IHUDSettings;
    protected _settings: IHUDSettings;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._type = HUDModule._typeName;

        this._defaultSettings = {
            axesCross: {
                enabled: false
            },
            compass: {
                enabled: true,
                type: CompassTypeEnum.LIGHT,
                tilt: true
            },
            sightPoint: {
                enabled: false,
                width: 3,
                height: 3,
                textureUrl: ""
            }
        };

        this._settings = Settings.clone(this._defaultSettings);
    }

    public static getClassType(): string {
        return HUDModule._typeName;
    }

    public getCompassRotationOffset(): number {
        // the local coordinate system of the models exported from y have the negative z axis (north) rotated against the
        // world compass which has negative z axis (north) at zero degrees. So we have to offset the rotation by 90 degrees
        let yRotation = Math.PI / 2.0;

        // then we take the main models's zeropoint rotation and add it to the yRotation
        let mainModel = this.sceneAPI.getDocument().getMainModel();
        let zeropoint = mainModel.getZeropointSettingsRef().zeropoint;
        if (zeropoint) {
            yRotation = yRotation + zeropoint.getRotation();
        }

        return yRotation;
    }

    public getCompassType(): CompassTypeEnum {
        return this._settings.compass.type;
    }

    public isSightPointEnabled(): boolean {
        return this._settings.sightPoint.enabled;
    }

    public getCompassIsEnabled(): boolean {
        return this._settings.compass.enabled;
    }

    public getCompassTiltIsEnabled(): boolean {
        return this._settings.compass.tilt;
    }

    public getAxesCrossIsEnabled(): boolean {
        return this._settings.axesCross.enabled;
    }

    public setArrowsMargin(aValue: number) {
        // we need to pass all views and set the arrows enabled
        let views = this.sceneAPI.viewModeModule.getViews();
        for (let v in views) {
            let view = views[v];
            view.getHud().setArrowsMargin(aValue);
        }

        this.sceneAPI.viewModeModule.scheduleRedraw();
    }

    public viewChanged() {
        //
    }

    public viewResized(aContentSize: vec2) {
        //
    }

    public setFromModelDescription(aJsonObject: any) {
        let settings: IHUDSettings = {};
        if (aJsonObject.hasOwnProperty(HUDModule._typeName)) {
            settings = aJsonObject[HUDModule._typeName];
        }
        this.set(settings);
    }

    protected applySettings(aChangedSettings: any, aPreviousSettings: any) {

        if (aChangedSettings.hasOwnProperty("compass")) {
            if (aChangedSettings.compass.hasOwnProperty("tilt")) {
                this.sceneAPI.viewModeModule.scheduleRedraw();
            }

            if (aChangedSettings.compass.hasOwnProperty("type")) {
                this.sceneAPI.viewModeModule.scheduleRedraw();
            }

            if (aChangedSettings.compass.hasOwnProperty("enabled")) {
                this.sceneAPI.viewModeModule.scheduleRedraw();
            }
        }

        if (aChangedSettings.hasOwnProperty("axesCross")) {
            if (aChangedSettings.axesCross.hasOwnProperty("enabled")) {
                this.sceneAPI.viewModeModule.scheduleRedraw();
            }
        }
    }

    protected notifySettings(aChangedSettings: any, aPreviousSettings: any) {
        if (aChangedSettings.hasOwnProperty("background")) {
            let bgModule = aChangedSettings['background'];
            if (bgModule.hasOwnProperty("background")) {
                let bg = bgModule['background'];
                if (bg.hasOwnProperty('type') || bg.hasOwnProperty('color')) {

                    let type: CompassTypeEnum = (this.sceneAPI.getModuleByType('background') as IBackgroundModule).isBackgroundColorLight()
                        ? CompassTypeEnum.DARK : CompassTypeEnum.LIGHT;
                    this.set({compass: {type: type}});
                }
            }
        }
    }

    protected setSightMarkEnabled(aValue: boolean) {
        /*if (!aValue && this.isSightMarkEnabled()) {
            this._sightmark.sapiElement.remove();
            this._sightmark.sapiElement = null;
        } else if (aValue && !this.isSightMarkEnabled()) {
            this._sightmark.sapiElement = this.sceneAPI.getDocument().createAPIElement(SightPoint.TypeName);
            this._sightmark.sapiElement.setSize(3, 3);
            //this._sightmark.sapiElement.setTexture(...); // keep it default in from sight point element
            this._sightmark.sapiElement.draw();
        }*/
    }
}

Scene.registerSceneAPIModule(HUDModule);
